import React from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Form from "./components/Form/Form";

const Landing = () => {
  return (
    <>
      <Header />
      <Form />
      <Footer />
    </>
  );
};

export default Landing;